<!--
 * @Author: zhangweinan
 * @Date: 2022-10-08 16:29:28
 * @LastEditors: WeijianXu weijian.xu@unidt.com
 * @LastEditTime: 2024-07-01 10:22:32
 * @Description: file content
 * @FilePath: /manage_property/src/components/frame/index.vue
-->
<template>
  <frame-layout :direction="'vertical'">
    <template #header>
      <Header :menus="headMenus" />
    </template>
    <!-- 上下布局，默认没有侧边栏 -->
    <slot v-if="isShow"></slot>
  </frame-layout>

  <DialogRegistry v-model:visible="registryShow" />
</template>
<script>
export default {
  name: 'FrameMain',
};
</script>
<script setup>
import { computed, onMounted, ref } from 'vue';
import { FrameLayout } from 'ai-assistant-lib';
import Header from './Header.vue';
import storeMenu from '@/config/storeMenu.js';
import { euserValidate } from '@/data/ApiUser';
import storeAccount from '@/config/storeAccount.js';
import DialogRegistry from '@/components/frame/widgets/DialogRegistry.vue';
import { useRoute } from 'vue-router';
import { ElMessage } from 'element-plus';
const account = storeAccount();

const props = defineProps({
  headerMenus: {
    type: Array,
    default: () => [],
  },
});

const StoreMenu = storeMenu();

const headMenus = computed(() => (props.headerMenus.length ? props.headerMenus : StoreMenu.headerMenu));

const isShow = ref(false);
const registryShow = ref(false);

const route = useRoute();

const fullPath = route.fullPath;

console.log('fullPath', fullPath);

onMounted(() => {
  if (fullPath == '/portal/application') {
    goControlDesk();
  } else {
    isShow.value = true;
  }
});
const goControlDesk = () => {
  if (account.isLogin) {
    euserValidate().then((res) => {
      if (res.success) {
        isShow.value = true;
      } else if (res.type == 2) {
        registryShow.value = true;
      } else {
        ElMessage.warning(res.message);
      }
    });
  }
};
</script>
<style lang="scss"></style>
